module.exports = __webpack_public_path__ + "img/app4.5b1cf994.png";